import type { RefObject } from "react";
import { useCallback, useRef } from "react";

import { useUnmount } from "app/custom-hooks/useUnmount";

import { TABLE_IS_SCROLL_CS } from "../components/styles";

const SCROLL_END_DELAY = 150;

type HookValue = {
    onScroll: VoidFunction;
};

export function useTableScrollHandlers(wrapperRef: RefObject<HTMLDivElement | null>): HookValue {
    const scrollTimeoutRef = useRef<ReturnType<typeof setTimeout>>(null);

    const onScroll = useCallback(() => {
        const wrapper = wrapperRef.current;
        if (!wrapper) {
            return;
        }

        wrapper.classList.add(TABLE_IS_SCROLL_CS);

        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current);
        }

        scrollTimeoutRef.current = setTimeout(() => {
            wrapper.classList.remove(TABLE_IS_SCROLL_CS);
        }, SCROLL_END_DELAY);
    }, [wrapperRef]);

    useUnmount(() => {
        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current);
        }
    });

    return { onScroll };
}
